export default __webpack_public_path__ + "static/media/Logo-HC-Russia-09-07-58-064.084ca595.svg";